/* global mc4wp, translation */
jQuery(($) => {
  if (typeof mc4wp !== 'undefined') {
    mc4wp.forms.on('success', (form, data) => {
      if (data) {
        if (data.CREATE_ACCOUNT) {
          const postData = {
            action: 'mailchimp_user_create',
            mailchimpPostedData: data,
          };

          $.post(translation.ajaxurl, postData, (response) => {
            if (response && response.data && response.data.length) {
              $('.mc4wp-response .mc4wp-alert').append(response.data);
            }
          });
        }
      }
    });
  }
});
